<template>
  <div>
    <!-- End .breadcrumb-nav -->
    <LoadedComponent :loading="loading" />

    <!-- Componente alert -->
    <!-- <AlertComponent :message="successMessage" :alert-type="'success'" /> -->

    <div class="container-fluid mb-4" v-if="!loading">
      <div class="row">
        <div class="col-12 mt-4">
          <div class="card shadow-sm bg-white p-lg-5 p-2">
            <div class="row">
              <div class="col-md-9">
                <div class="widget widget-search">
                  <form method="post" id="cipriani-general-search">
                    <label for="ws" class="sr-only">Cerca fra i casi</label>
                    <input type="search" class="form-control" name="q" id="ws" v-model="searchText"
                      placeholder="Cerca il titolo fra le discussioni" @input="performSearchForum" required />
                    <button type="button" class="btn">
                      <i class="icon-search"></i><span class="sr-only">Cerca</span>
                    </button>
                  </form>
                </div>
                <!-- End .widget -->
              </div>
              <!-- Controlla che lo possa utilizzare-->
              <div class="col-md-3">
                <!-- pt-0 pt-md-2 pl-0 pl-md-5  mb-0 mb-md-4 -->
                <button type="button" class="btn btn-outline-secondary nav-link w-100" data-toggle="modal"
                  data-target="#forum-create-modal">
                  Crea una nuova discussione
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="container-fluid mb-4" v-if="!loading">
      <!-- Blog Post -->
      <div class="col-sm-12">
        <div>
          <div class="row reload-forum-page" v-if="forums.length > 0">
            <div class="col-lg-6" v-for="forum in forums" :key="forum.id">
              <div class="card">
                <div class="card-header">
                  <h4 class="text-center text-dark">
                    <router-link :to="'/forum/' + forum.slug" class="text-dark">{{ forum.name }}</router-link>
                  </h4>
                </div>
                <div class="card-body">
                  <!-- End .entry-cats -->

                  <div class="entry-content p-4">
                    <p class="col-12 text-truncate">
                      {{ forum.description }}
                    </p>
                    <div class="text-center">
                      <router-link :to="'/forum/show/' + forum.slug" class="btn btn-info" v-if="forum.show_forum">Entra
                        nella discussione</router-link>
                    </div>
                  </div>
                  <div class="text-center">
                    <!-- End .entry-content -->
                    <div class="entry-meta pt-4">
                      <span class="entry-author">
                        Pubblicato da <span>{{ forum.full_name }}</span>
                      </span>
                      <span class="meta-separator">|</span>
                      <a href="data-">{{ forum.publish_date }}</a>
                      <span class="meta-separator">|</span>
                      <a>{{ forum.hospital }}</a>
                    </div>
                  </div>
                  <!-- End .entry-meta -->
                </div>
                <!-- End .entry-body -->
              </div>
              <!-- End .row -->
            </div>
            <!-- End .col-lg-9 -->
            <hr />
          </div>

          <div class="row reload-forum-page" v-else>
            <p>Nessun risltato</p>
          </div>
        </div>
        <!-- End .row -->
      </div>
    </div>
    <div class="modal fade" id="forum-create-modal" tabindex="-1" role="dialog" aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
          <div class="modal-body">
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true"><i class="icon-close"></i></span>
            </button>

            <div class="form-box">
              <div class="form-tab">
                <ul class="nav nav-pills nav-fill" role="tablist">
                  <li class="nav-item">
                    <a class="nav-link" id="signin-tab" data-toggle="tab" href="#signin" role="tab"
                      aria-controls="signin" aria-selected="true">Nuova discussione</a>
                  </li>
                </ul>
                <div class="tab-content" id="tab-content-5">
                  <div class="tab-pane fade show active" id="signin" role="tabpanel" aria-labelledby="signin-tab">
                    <form @submit.prevent="sendNewForum">
                      <div class="form-group">
                        <label for="title-forum">Titolo discussione</label>
                        <input type="text" class="form-control" id="title-forum" name="nome" v-model="form.name"
                          placeholder="Scrivi il titolo della discussione" />
                      </div>
                      <!-- End .form-group -->
                      <div class="alert alert-danger" v-if="errors.name">
                        {{ errors.name[0] }}
                      </div>

                      <div class="form-group">
                        <label for="description-forum">Messaggio</label>
                        <textarea class="form-control" id="description-forum" name="descrizione"
                          v-model="form.description" placeholder="Descrivi la discussione "></textarea>
                      </div>
                      <!-- End .form-group -->
                      <div class="alert alert-danger" v-if="errors.description">
                        {{ errors.description[0] }}
                      </div>

                      <div class="form-footer">
                        <button type="submit" class="btn btn-outline-primary-2 btn-order btn-block">
                          <span class="btn-text">Invia</span>
                          <span class="btn-hover-text">Pubblica la discussione</span>
                        </button>
                      </div>
                      <!-- End .form-footer -->
                    </form>
                  </div>
                  <!-- .End .tab-pane -->
                </div>
                <!-- End .tab-content -->
              </div>
              <!-- End .form-tab -->
            </div>
            <!-- End .form-box -->
          </div>
          <!-- End .modal-body -->
        </div>
        <!-- End .modal-content -->
      </div>
      <!-- End .modal-dialog -->
    </div>

    <!-- End .modal -->
  </div>
</template>

<script>
import httpauth from "@/services/httpauth.js";
import { useAuth } from "@/stores/auth.js";
import LoadedComponent from "@/components/LoadedComponent.vue";
import { useToast } from "vue-toast-notification";
import "vue-toast-notification/dist/theme-sugar.css";
import $ from "jquery";
window.jQuery = $;
window.$ = $;
export default {
  name: "ForumPage",
  props: {},
  components: { LoadedComponent },
  data() {
    return {
      forums: [],
      searchText: "",
      allForum: [],
      errors: [],
      loading: true,
      form: {
        name: "",
        description: "",
      },
    };
  },
  mounted() {
    var successMessage = localStorage.getItem("messageSuccessForum");
    if (successMessage)
    {
      const $toast = useToast();
      $toast.open({
        message: successMessage,
        type: "success",
        position: "top-right",
        // all of other options may go here
      });
      localStorage.removeItem("messageSuccessForum");
    }

    httpauth
      .get("/forum")
      .then((response) => {
        var data = response.data;
        this.forums = data.data;
        this.allForum = data.data;
        this.loading = false;

        // Gestisci l'array di oggetti come desiderato
      })
      .catch((error) => {
        if (
          error.response.status == 401 &&
          error.response.data.message == "Unauthenticated."
        )
        {
          const auth = useAuth();
          auth.clearToken();
          window.location.href = "/";
        }
      });
  },
  created() { },
  methods: {
    performSearchForum() {
      if (!this.searchText)
      {
        this.forums = this.allForum;
        return;
      }
      var searchTerm = this.searchText.toLowerCase();
      this.forums = this.allForum.filter(
        (item) =>
          item.name.toLowerCase().includes(searchTerm) ||
          item.description.toLowerCase().includes(searchTerm)
      );
    },
    async sendNewForum() {
      await httpauth
        .post("/forum", this.form)
        .then((response) => {
          const $toast = useToast();
          $toast.open({
            message: response.data.message,
            type: "success",
            position: "top-right",
            // all of other options may go here
          });
          $("#forum-create-modal").modal("hide");
          this.forums = response.data.data;
          this.form.name = "";
          this.form.description = "";
        })
        .catch((error) => {
          if (error.response.data.errors)
          {
            this.errors = error.response.data.errors;
          }
        });
    },
  },
};
</script>